import { render, staticRenderFns } from "./GreyPanel.vue?vue&type=template&id=3a4b1edb&"
import script from "./GreyPanel.vue?vue&type=script&lang=ts&"
export * from "./GreyPanel.vue?vue&type=script&lang=ts&"
import style0 from "./GreyPanel.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports